import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { Gamepad2, LogOut, User, Plus, LayoutDashboard, List, Shield, MessageSquare } from "lucide-react";

function DashboardNav() {
  const { currentUser, userProfile, logout } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate("/");
  }

  return (
    <nav className="border-b border-gray-800/50 bg-gray-950/80 backdrop-blur-xl sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-6">
            <Link to="/dashboard" className="flex items-center gap-2">
              <Gamepad2 className="w-7 h-7 text-brand-400" />
              <span className="text-lg font-bold bg-gradient-to-r from-brand-400 to-purple-400 bg-clip-text text-transparent">
                referred.games
              </span>
            </Link>
            <div className="hidden sm:flex items-center gap-1">
              {userProfile?.role !== "admin" && <Link
                to="/dashboard"
                className="flex items-center gap-2 text-sm text-gray-400 hover:text-white px-3 py-2 rounded-lg hover:bg-white/5 transition-all"
              >
                <LayoutDashboard className="w-4 h-4" />
                Dashboard
              </Link>}
              {userProfile?.role !== "admin" && <Link
                to="/campaigns"
                className="flex items-center gap-2 text-sm text-gray-400 hover:text-white px-3 py-2 rounded-lg hover:bg-white/5 transition-all"
              >
                <List className="w-4 h-4" />
                Campaigns
              </Link>}
              {userProfile?.role === "publisher" && (
                <Link
                  to="/campaigns/create"
                  className="flex items-center gap-2 text-sm text-gray-400 hover:text-white px-3 py-2 rounded-lg hover:bg-white/5 transition-all"
                >
                  <Plus className="w-4 h-4" />
                  Create Campaign
                </Link>
              )}
              {userProfile?.role === "influencer" && (
                <Link
                  to="/profile"
                  className="flex items-center gap-2 text-sm text-gray-400 hover:text-white px-3 py-2 rounded-lg hover:bg-white/5 transition-all"
                >
                  <User className="w-4 h-4" />
                  Profile
                </Link>
              )}
              {userProfile?.role === "publisher" && (
                <Link
                  to="/publisher-profile"
                  className="flex items-center gap-2 text-sm text-gray-400 hover:text-white px-3 py-2 rounded-lg hover:bg-white/5 transition-all"
                >
                  <User className="w-4 h-4" />
                  Profile
                </Link>
              )}
              {userProfile?.role === "admin" && (
                <Link
                  to="/admin"
                  className="flex items-center gap-2 text-sm text-gray-400 hover:text-white px-3 py-2 rounded-lg hover:bg-white/5 transition-all"
                >
                  <Shield className="w-4 h-4" />
                  Admin Panel
                </Link>
              )}
              <Link
                to="/contact"
                className="flex items-center gap-2 text-sm text-gray-400 hover:text-white px-3 py-2 rounded-lg hover:bg-white/5 transition-all"
              >
                <MessageSquare className="w-4 h-4" />
                Contact
              </Link>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <User className="w-4 h-4" />
              <span className="hidden sm:inline">{currentUser?.displayName || currentUser?.email}</span>
              {userProfile?.role && (
                <span className={`text-xs px-2 py-0.5 rounded-full ${
                  userProfile.role === "admin"
                    ? "bg-red-500/10 text-red-400 border border-red-500/20"
                    : userProfile.role === "publisher"
                    ? "bg-blue-500/10 text-blue-400 border border-blue-500/20"
                    : "bg-purple-500/10 text-purple-400 border border-purple-500/20"
                }`}>
                  {userProfile.role}
                </span>
              )}
            </div>
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-300 transition-colors"
            >
              <LogOut className="w-4 h-4" />
              <span className="hidden sm:inline">Sign out</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default DashboardNav;
